import{useEffect as n}from"react";function a(e,t=[],c=300){n(()=>{const f=setTimeout(e,c);return()=>clearTimeout(f)},t)}export{a as useDebouncedEffect};
